module.exports = __webpack_public_path__ + "71da505f6bc8252c81115b2e935bb914.png";